import {
  ADD_INTRESTED,
  ADD_INTRESTED_FAILURE,
  ADD_INTRESTED_SUCCESS,
  EDIT_INTRESTED,
  EDIT_INTRESTED_FAILURE,
  EDIT_INTRESTED_SUCCESS,
} from '../Actiontype';

export const AddIntersted = data => ({
  payload: data,
  type: ADD_INTRESTED,
});
export const AddInterstedSuccess = response => ({
  payload: response,
  type: ADD_INTRESTED_SUCCESS,
});
export const AddInterstedFailure = response => ({
  payload: response,
  type: ADD_INTRESTED_FAILURE,
});
export const EditIntersted = data => ({
  payload: data,
  type: EDIT_INTRESTED,
});
export const EditInterstedSuccess = response => ({
  payload: response,
  type: EDIT_INTRESTED_SUCCESS,
});
export const EditInterstedFailure = response => ({
  payload: response,
  type: EDIT_INTRESTED_FAILURE,
});
